var map = {
	"./logo1.png": 911,
	"./logo10.png": 495,
	"./logo11.png": 478,
	"./logo12.png": 277,
	"./logo2.png": 804,
	"./logo3.png": 693,
	"./logo4.png": 818,
	"./logo5.png": 675,
	"./logo6.png": 920,
	"./logo7.png": 401,
	"./logo8.png": 206,
	"./logo9.png": 223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;